/* eslint-disable max-len */
/** @jsx jsx */
import React, { useEffect, useLayoutEffect, useRef, useState} from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';
import { textColor } from 'components/styles';
import BreadCrumb from "components/atoms/BreadCrumb";
import { getMenuListByRole, menuSuperAdministrator } from './menuData'
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
const isPhone = window.matchMedia("(max-width: 480px)").matches;
const ispad = window.matchMedia("(max-width: 1024px)").matches;

const styles = {
  formHeader: (width?: any) => css({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    position: 'fixed',
    top: '65px',
    width: width + 'px',
    zIndex: 120,
    background: '#FAFBFC',
    padding: '16px 15px',
  }),
  title: css({
    fontsize: isPhone? '12px': (ispad? '14px': '16px'),
  })
};

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}
const FormHeader: React.FC<{
  title: string,
  customStyle?: SerializedStyles;
}> = ({ title, customStyle }) => {
  
  const site: string | null = sessionStorage.getItem('loginUser.site') || "";
  const isAdministrator: string | null = sessionStorage.getItem('loginUser.administrator') || "";
  const refParent = useRef(Object());
  const collapsedSidebar = useSelector((state:Store) => state.ui.appBar.collapsedSidebar);
  const [offsetWidthTable, setOffsetWidthTable] = useState(0);
  const [width] = useWindowSize();
  const wrapContainner = document.querySelector('.block-ui-custom-container') as HTMLElement;
  useEffect(() => {
    if(wrapContainner && collapsedSidebar === false) {
      setOffsetWidthTable(wrapContainner.offsetWidth - 30);

    } else if(collapsedSidebar === true) {
      setOffsetWidthTable((wrapContainner.offsetWidth - 30)); 
    }
  },[collapsedSidebar, wrapContainner, width]);

  return (
    <div ref={refParent} css={css({ width:'100%' })}>
      <div css={styles.formHeader(offsetWidthTable || 0)}>
        <div css={[{ fontWeight: 'bold', color: textColor.main }, styles.title,customStyle]} style={{fontSize:isPhone? '12px': (ispad? '14px': '16px')}}>
          {title}
        </div>
        <BreadCrumb
          menu={getMenuListByRole(site, isAdministrator, menuSuperAdministrator)}
        />
      </div>
    </div>
  )
};

export default FormHeader;